import React from 'react';
import Select from 'react-select';
import './dropdown.css';

const Dropdown = ({
  label,
  disabled = false,
  width = 'w-full',
  options = [],
  value,
  onChange,
  className = '',
  icon,
  placeholder = 'Select an option',
  height,
  labelClass,
  isRequired,
  isRequiredClass,
  name,
  search,
  isMulti = false,
  onFieldSelect,
  zIndex,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = React.useState(isMulti ? [] : null);

  React.useEffect(() => {
    if (isMulti) {
      // For multi-select, ensure value is an array
      setSelectedValue(value || []);
    } else {
      // For single select, ensure value is an object or null
      setSelectedValue(value ? { label: value, value: value } : null);
    }
  }, [value, isMulti]);

  const handleChange = (selectedOptions) => {
    if (isMulti) {

      // For multi-select, selectedOptions is an array
      setSelectedValue(selectedOptions || []);
      if (onChange) {
        onChange(selectedOptions ? selectedOptions.map((opt) => opt.value) : []);
      }
      if (onFieldSelect) {
        onFieldSelect(selectedOptions || []);
      }
    } else {
      // For single select, selectedOptions is a single object or null
      setSelectedValue(selectedOptions || null);
      if (onChange) {
        onChange(selectedOptions ? selectedOptions.value : null);
      }
      if (onFieldSelect) {
        onFieldSelect(selectedOptions || null);
      }
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#2D9F75' : '#D1D5DB',
      borderRadius: '12px',
      boxShadow: state.isFocused ? '0 0 0 1px #2D9F75' : 'none',
      '&:hover': {
        borderColor: '#2D9F75',
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: '120px',
      overflowY: 'auto',
      zIndex: zIndex,
      borderRadius: '0.5rem',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#2D9F75' : state.isFocused ? '#E5F6F1' : 'white',
      color: state.isSelected ? 'white' : '#4B5563',
      padding: '8px 16px',
      borderRadius: '0.375rem',
    }),
  };

  return (
    <div className={`${width}`}>
      {label && (
        <label className={labelClass}>
          {label} {isRequired && <span className={isRequiredClass}>*</span>}
        </label>
      )}
      <div className={`${width} specific-container`}>
        <Select
          isDisabled={disabled}
          value={selectedValue}
          styles={customStyles}
          classNamePrefix="select"
          onChange={handleChange}
          isClearable={true}
          isSearchable={search || false}
          name={name}
          options={options}
          isMulti={isMulti}
          placeholder={placeholder}
          {...props}
        />
      </div>
    </div>
  );
};

export default Dropdown;